"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    InputLabel = function InputLabel(a) {
  var b = a.formId,
      c = a.id,
      d = a.label,
      e = a.isRequired,
      f = a.labelPlacement,
      g = a.styledComponent,
      h = (g || !1).Label,
      i = void 0 === h ? "label" : h;
  return _react["default"].createElement(i, {
    htmlFor: "input_".concat(b, "_").concat(c),
    className: "gf-label ".concat(f),
    style: {
      display: "hidden_label" === f ? "none" : void 0
    }
  }, d, e ? _react["default"].createElement("abbr", null, "*") : null);
},
    _default = InputLabel;

exports["default"] = _default;